export default "__VITE_ASSET__ce79da96__"